import * as React from "react";
import "./count-warning-tooltip.scss";
import {cs}         from "../../../../../react/chain-services";
import {Tooltip2}   from "../../../common/design2/tooltip-2/tooltip-2";

export const CountWarningTooltip = ({count=0, height = 23, getTooltip=undefined, direction=undefined, xdQaName=undefined}) => cs(
    ["tooltip", (_, next) => Tooltip2({
        getMessage: getTooltip,
        direction,
        next,
    })],
    ({tooltip}) => (
        <div
            className="warning-count-badge warning-count-badge-53s"
            ref={tooltip?.ref}
            style={{height, width:50}}
            onClick={tooltip?.onClick}
            onMouseEnter={tooltip?.onMouseEnter}
            onMouseLeave={tooltip?.onMouseLeave}
        >
            {tooltip?.render()}
            <div>
                {count}
            </div>
        </div>
    ),
);
